(() => {
  if (window.vh12SublineController) { window.vh12SublineController.refresh(); return; }
  const root = document.documentElement;
  const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  let element, letters = [], timer = null, dueAt = 0, remaining = 300;
  let active = false, phase = 'reveal', index = 0;
  const enabled = () => root.classList.contains('vh12-motion-ready') && !preference.matches;
  const visible = () => {
    if (!element) return false;
    const box = element.getBoundingClientRect(), viewport = window.visualViewport;
    const top = viewport ? viewport.offsetTop : 0;
    const bottom = top + (viewport ? viewport.height : window.innerHeight) - 72;
    return box.height > 0 && box.top >= top - 2 && box.bottom <= bottom + 2;
  };
  const canTick = () => active && enabled() && !root.classList.contains('vh12-motion-paused') && !document.hidden && visible();
  const pause = () => {
    if (timer !== null) { remaining = Math.max(0, dueAt - performance.now()); clearTimeout(timer); timer = null; }
  };
  const resetStatic = () => {
    pause(); active = false;
    if (element) element.classList.remove('vh12-sub-loop-active');
    letters.forEach(letter => letter.classList.remove('vh12-sub-visible'));
  };
  const schedule = () => {
    if (timer !== null || !canTick()) return;
    dueAt = performance.now() + remaining;
    timer = setTimeout(tick, remaining);
  };
  const tick = () => {
    timer = null;
    if (!canTick()) return;
    if (phase === 'reveal') {
      if (letters[index]) letters[index].classList.add('vh12-sub-visible');
      index += 1;
      if (index >= letters.length) { phase = 'hold'; remaining = 3200; }
      else remaining = 75;
    } else if (phase === 'hold') {
      letters.forEach(letter => letter.classList.remove('vh12-sub-visible'));
      phase = 'reset'; remaining = 300;
    } else {
      phase = 'reveal'; index = 0; remaining = 0;
    }
    schedule();
  };
  const sync = () => {
    if (!enabled()) { resetStatic(); return; }
    if (!active && element && letters.length && visible()) {
      index = 0; phase = 'reveal'; remaining = 300;
      letters.forEach(letter => letter.classList.remove('vh12-sub-visible'));
      element.classList.add('vh12-sub-loop-active'); active = true;
    }
    if (canTick()) schedule(); else pause();
  };
  const initialize = () => {
    const next = document.querySelector('.vh12-opening-sub');
    if (next !== element) {
      resetStatic(); element = next;
      letters = element ? Array.from(element.querySelectorAll('.vh12-sub-letter')) : [];
    }
    sync();
  };
  new MutationObserver(sync).observe(root, { attributes: true, attributeFilter: ['class'] });
  document.addEventListener('visibilitychange', sync);
  document.addEventListener('shopify:section:load', initialize);
  window.addEventListener('scroll', sync, { passive: true });
  window.addEventListener('resize', sync, { passive: true });
  window.addEventListener('load', initialize, { once: true });
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', sync, { passive: true });
    window.visualViewport.addEventListener('scroll', sync, { passive: true });
  }
  if (preference.addEventListener) preference.addEventListener('change', sync);
  else if (preference.addListener) preference.addListener(sync);
  window.vh12SublineController = { refresh: initialize };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
